import { Component } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router, ActivatedRoute } from "@angular/router";
import { AccountService, TestService } from "../../../api/services";
import { GlobalApp } from "../../../tools/global";
import { LoginLocal } from "../../../api/models";
import { ForgotPasswordService } from "../../../api/services/forgot-password.service";

@Component({
  selector: "confirm-email",
  templateUrl: "./confirm-email.component.html",
})
export class ConfirmEmailComponent {
  public emailAddress: string = "";
  public confirmationCode: string = "";
  public confirming: boolean = true;
  public confirmed: boolean = false;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private globalApp: GlobalApp,
    private forgotPasswordService: ForgotPasswordService,
    private route: ActivatedRoute
  ) {
    this.route.paramMap.subscribe((params) => {
      this.emailAddress = params.get("emailAddress");
      this.confirmationCode = params.get("confirmationCode");

      var srcParams: AccountService.AccountValidateEmailParams = {
        emailAddress: params.get("emailAddress"),
        validationGuid: params.get("confirmationCode"),
      };

      this.accountService
        .accountValidateEmail(srcParams)
        .subscribe((result) => {
          this.confirming = false;
          this.confirmed = result;
        });
    });
  }
}
